function updatePackHelpers() {
  document.querySelectorAll('.pack-helper').forEach(helper => {
    const title = helper.dataset.variantTitle || '';

    const cartItem =
      helper.closest('.cart-item') ||
      helper.closest('.cart-drawer__item') ||
      helper.closest('tr');

    const quantityInput =
      cartItem?.querySelector('.quantity__input') ||
      cartItem?.querySelector('[name^="updates"]');

    const quantity = parseInt(quantityInput?.value, 10) || 1;

    const match = title.match(/(\d+)\s*(pack|packs|vial|vials|x)/i);
    if (!match) {
      helper.innerHTML = '';
      return;
    }

    const packSize = parseInt(match[1], 10);
    if (!packSize || packSize <= 1) {
      helper.innerHTML = '';
      return;
    }

    const totalVials = packSize * quantity;

    helper.innerHTML = `
      <div style="font-size:12px; color:#555; margin-top:4px;">
        <strong>Total vials:</strong> ${totalVials}
        <span style="color:#777;">
          (${quantity} pack${quantity > 1 ? 's' : ''} x ${packSize} vials)
        </span>
      </div>
    `;
  });
}

/* Initial load */
document.addEventListener('DOMContentLoaded', updatePackHelpers);

/* Quantity buttons */
document.addEventListener('click', e => {
  if (e.target.closest('.quantity__button')) {
    requestAnimationFrame(updatePackHelpers);
  }
});

/* Quantity input typing */
document.addEventListener('input', e => {
  if (e.target.closest('.quantity__input')) {
    requestAnimationFrame(updatePackHelpers);
  }
});

/* Dawn cart redraws */
document.addEventListener('cart:updated', () => {
  requestAnimationFrame(updatePackHelpers);
});
